import React, { Component } from 'react';
import ReactDOM from 'react-dom';       //Renders to DOM
import axios from 'axios';
import $ from 'jquery';
import { HashRouter as Router} from 'react-router-dom';  // Enables routing between the components
//import { browserHistory } from 'react-router';
import { Provider } from "react-redux"; //Wraps whole app and gives store as a prop. 
import store from './store/configureStore';

// Importing css files and dependant css files
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

// Importing Components
import * as url from './api/url';
import RouterComponent from './Router/RouterComponent';
import { unregister } from './registerServiceWorker';

export const ServiceRequestContext = React.createContext();

class App extends Component {
    constructor(props){
        super(props);
        this.state = {
            HasWOFormAccess: true,
            serviceRequestDetails: null,
            woTenantStdFieldDetails: null,
        }
    }

    componentDidMount(){
        var querystring = window.location.href.indexOf("React/#/ServiceRequest");
        if(querystring !== -1){
            var newurl = window.location.href.substring(0, querystring);
            newurl = newurl + "ServiceRequest";
            window.history.replaceState({ path: newurl }, '', newurl);
        }

        axios.get(url.get_WorkOrder_Form_Access).then(
            response => {
                if(response.status === 200)
                    this.setState({ HasWOFormAccess : response.data.woLicense, 
                        serviceRequestDetails: response.data.values,
                        woTenantStdFieldDetails: response.data.tenantDetails })
            })
    }

    render() {

        let basename_path = "/";
       
        return (
            <Router basename={basename_path}>
                <div style={{ "height": "100%" }}>
                    <ServiceRequestContext.Provider value={{ "HasWOFormAccess": this.state.HasWOFormAccess, "ServiceRequestDetails": this.state.serviceRequestDetails, "WOTenantStdFieldDetails": this.state.woTenantStdFieldDetails }}>
                        <RouterComponent />     {/*    fetches the routing system from Router Component. In order to create routing links, visit router Components */}
                    </ServiceRequestContext.Provider>
                </div>
            </Router>
        );
    }
}

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>
    , document.getElementById('root'));
    unregister();


    $(function() {
        $('#btn_CreateWorkOrder').click(function() {
            var l_SiteId = $('#btn_CreateWorkOrder').attr('data-siteid');
            var l_ObjectId = $('#btn_CreateWorkOrder').attr('data-objectid');
            var l_Description = $('#btn_CreateWorkOrder').attr('data-description');

            console.log(l_SiteId +", "+ l_ObjectId);

            var SiteId = (l_SiteId !== undefined && l_SiteId != null && l_SiteId > 0) ? l_SiteId : 0;
            var ObjectId = (l_ObjectId !== undefined && l_ObjectId != null && l_ObjectId > 0) ? l_ObjectId : 0;
            window.AlarmWrapper.Show(SiteId,ObjectId,l_Description);
        });
      });

      $(function() {
        $('#btn_CreateWorkOrderEquipmentWorkorder').click(function() {
            var l_SiteId = $('#btn_CreateWorkOrderEquipmentWorkorder').attr('data-siteid');
            var l_ObjectId = $('#btn_CreateWorkOrderEquipmentWorkorder').attr('data-objectid');
            var l_Description = $('#btn_CreateWorkOrderEquipmentWorkorder').attr('data-description');

            console.log(l_SiteId +", "+ l_ObjectId);

            var SiteId = (l_SiteId !== undefined && l_SiteId != null && l_SiteId > 0) ? l_SiteId : 0;
            var ObjectId = (l_ObjectId !== undefined && l_ObjectId != null && l_ObjectId > 0) ? l_ObjectId : 0;
            window.EquipmentAlarmWrapper.Show(SiteId,ObjectId,l_Description);
        });
      });
